import { NotFound } from '../errors/errorClasses/notFound';
/** Util function for getting the MfsCard object representing an unique Card */
export function getMfsItem(dataStore, mfsLabelId, mfsLabel) {
    var _a;
    return (_a = dataStore.getItemsByLabel((item) => true, mfsLabel, mfsLabelId).next()) === null || _a === void 0 ? void 0 : _a.value;
}
/**
 * Gets the MfsItem by label and labelId. Throws an error if no MfsItem exists.
 * @param dataStore MfsDataStore
 * @param mfsLabelId Unique id of the mfsItem
 * @param mfsLabel Label of the mfsItem
 * @returns The requested MfsItem
 * @throws If the MfsItem does not exist
 */
export function getMfsItemOrThrowError(dataStore, mfsLabelId, mfsLabel) {
    const mfsItem = getMfsItem(dataStore, mfsLabelId, mfsLabel);
    if (!mfsItem) {
        throw new NotFound(`Unable to find target ${mfsLabel} when it does not exist.`);
    }
    return mfsItem;
}
/**
 * Takes an array of values and chunks them into groups.
 * @param arr Array of values to batch
 * @param batchSize Number of values per batch
 * @returns Array of batches of values
 */
export function splitArrayToBatches(arr, batchSize) {
    return arr.reduce((prev, cur) => {
        if (prev.length === 0 || prev[prev.length - 1].length === batchSize)
            prev.push([]);
        prev[prev.length - 1].push(cur);
        return prev;
    }, []);
}
//# sourceMappingURL=utils.js.map